import { LOCALE_MAP_TO_I18N_TS } from "constants/lang";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

import resources from "./resources";
import { getLanguageType } from "./weglot";

const languageType = getLanguageType();
const initialLanguage = LOCALE_MAP_TO_I18N_TS[languageType.value];

/**
 * 表示する言語の翻訳を読み込み終えると解決する。
 * resources に無い言語は backend が読み込み、読み込めなかったときも解決して
 * fallbackLng の日本語で表示する
 */
export const i18nextInitialization = i18next
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      async (language: string) =>
        import(`./namespace/${language}/resource.json`)
    )
  )
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: "ja",
    debug: process.env.NODE_ENV === "development",
    resources,
    partialBundledLanguages: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
